import { CoreMenu, Role } from "@core/models";
export const menu: CoreMenu[] = [
  {
    id: "dashboard",
    title: "Dashboard",
    type: "item",
    customIcon: "dashboard",
    url: "dashboard",
    role: [
      Role.Admin,
      Role.Teacher,
      Role.SuperAdmin,
      Role.Student,
      Role.independentStudent,
    ]
  },
  {
    id: "dashboard-parent",
    title: "Dashboard",
    type: "item",
    customIcon: "dashboard",
    url: "cbc/dashboard/parent",
    role: [Role.Parent],
  },
  {
    id: "mySchool",
    title: "My School",
    type: "item",
    customIcon: "mySchool",
    url: "assignments/student",
    role: [
      Role.Student,
      Role.independentStudent
    ],
  },
  {
    id: "learn",
    title: "Learn",
    type: "item",
    icon: "play-circle",
    url: "learn",
    role: [
      Role.SuperAdmin,
      Role.Admin,
      Role.Teacher,
      Role.CustomerSupportAdmin,
    ],
  },
  {
    id: "cbc-dashboard-teacher",
    title: "Dashboard",
    type: "item",
    customIcon: "dashboard",
    url: "cbc/dashboard/teacher",
    role: [Role.CbcTeacher],
  },
  {
    id: "cbc",
    title: "Learn",
    type: "item",
    icon: "tv",
    url: "cbc/learn",
    role: [Role.CbcStudent, Role.CbcTeacher],
  },
  {
    id: "assignments",
    title: "Assignments",
    type: "item",
    customIcon: "assignments",
    url: "cbc/assignments",
    role: [Role.CbcStudent, Role.CbcTeacher],
  },
  {
    id: "assignments-legacy",
    title: "Assignments",
    type: "item",
    customIcon: "assignments",
    url: "assignments",
    role: [Role.Teacher, Role.Admin],
  },
  {
    id: "notes",
    title: "Notes",
    type: "item",
    customIcon: "notes",
    url: "cbc/notes",
    role: [Role.CbcStudent, Role.CbcTeacher],
  },
  {
    id: "teacher-tools",
    title: "Teacher tools",
    type: "item",
    customIcon: "assignments",
    url: "cbc/teacher-tools",
    role: [Role.CbcTeacher],
    feature: "TEACHER_TOOLS",
  },
  {
    id: "zeraki-academy",
    title: "Zeraki Academy",
    type: "item",
    icon: "tv",
    url: "zeraki-academy/learn",
    role: [
      Role.Admin,
      Role.Teacher,
      Role.CbcTeacher,
      Role.SuperAdmin,
    ],
  },
  {
    id: "notes-legacy",
    title: "Notes",
    type: "item",
    customIcon: "notes",
    url: "notes",
    role: [Role.Teacher, Role.Admin],
  },
  {
    id: "quiz",
    title: "Quizzes",
    type: "item",
    icon: "help-circle",
    url: "quiz/normal-quiz",
    role: [Role.Teacher, Role.Admin, Role.SuperAdmin],
  },
  {
    id: "exams",
    title: "Examinations",
    type: "item",
    customIcon: "exams",
    url: "exams",
    role: [
      Role.Admin,
      Role.Teacher,
      Role.CbcTeacher,
      Role.SuperAdmin,
      Role.Student,
      Role.independentStudent,
      Role.CbcStudent
    ]
  },
  {
    id: "school",
    title: "My school",
    type: "item",
    customIcon: "mySchool",
    url: "school",
    role: [Role.Admin],
  },
  {
    id: "schools",
    title: "Schools",
    type: "item",
    icon: "briefcase",
    url: "schools",
    role: [Role.SuperAdmin, Role.CustomerSupportAdmin],
  },
  {
    id: "upload",
    title: "Upload",
    type: "item",
    icon: "upload",
    url: "upload",
    role: [Role.SuperAdmin],
  },
  {
    id: "achievements",
    title: "Achievements",
    type: "item",
    icon: "star",
    url: "quiz/leaderboard",
    role: [Role.Student, Role.independentStudent],
  },
  {
    id: "careers",
    title: "Careers",
    type: "item",
    customIcon: "careers",
    url: "careers",
    role: [Role.Student, Role.independentStudent],
  },
  {
    id: "cahoot",
    title: "BeeWiz",
    type: "item",
    icon: "book-open",
    url: "beewiz",
    role: [
      Role.Student,
      Role.independentStudent,
      Role.Teacher,
      Role.Admin
    ],
  },
  {
    id: "bookmark",
    title: "Saved Items",
    type: "item",
    icon: "bookmark",
    url: "bookmarks",
    role: [
      Role.Student,
      Role.independentStudent,
      Role.Teacher,
      Role.Admin
    ],
  },

  {
    id: "subscribe",
    title: "Subscriptions",
    type: "item",
    customIcon: "fees",
    url: "cbc/dashboard/subscribe",
    role: [
      Role.Parent, Role.CbcStudent
    ],
  },
  // {
  //   id: "logout",
  //   title: "Log Out",
  //   type: "item",
  //   icon: "log-out",
  //   url: "logout",
  // },
];
